import React from 'react'
import { Layer } from 'grommet'
import WheelTabs from '../WheelTabs'
import { useSelector, useDispatch } from 'react-redux'
import { displayNewWheelDrop } from '../../redux/modal/actions'

const NewWheelDrop = ({ page }) => {
  const showNewWheelDrop = useSelector(state => state.modal.newWheelDrop)
  const dispatch = useDispatch()
  return (
    <>
      {showNewWheelDrop && (
        <Layer
          onEsc={() => dispatch(displayNewWheelDrop(false))}
          onClickOutside={() => dispatch(displayNewWheelDrop(false))}
        >
          <WheelTabs page={page} />
        </Layer>
      )}
    </>
  )
}

export default NewWheelDrop
